import { render, staticRenderFns } from "./doctorSupervise.vue?vue&type=template&id=4f524b2d&scoped=true&"
import script from "./doctorSupervise.vue?vue&type=script&lang=js&"
export * from "./doctorSupervise.vue?vue&type=script&lang=js&"
import style0 from "./doctorSupervise.vue?vue&type=style&index=0&id=4f524b2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f524b2d",
  null
  
)

export default component.exports